/**
 * AUTO-GENERATED — do not edit manually.
 * Run: bun run generate:permissions
 *
 * This file is generated from backend/src/Security/Permission/PermissionCode.php
 */

export const PERMISSIONS = {
  CREATION: {
    EMPLOYES: {
      VIEW: "creation.employes.view",
    },
    ARTICLES: {
      VIEW: "creation.articles.view",
      CREATE: "creation.articles.create",
      EDIT: "creation.articles.edit",
      DELETE: "creation.articles.delete",
      ARCHIVE: "creation.articles.archive",
      EXPORT: "creation.articles.export",
      IMPORT: "creation.articles.import",
    },
    DOCUMENTS: {
      VIEW: "creation.documents.view",
      CREATE: "creation.documents.create",
      EDIT: "creation.documents.edit",
      DELETE: "creation.documents.delete",
      DOWNLOAD: "creation.documents.download",
      UPLOAD: "creation.documents.upload",
      EXPORT: "creation.documents.export",
    },
    ATELIERS: {
      VIEW: "creation.ateliers.view",
      CREATE: "creation.ateliers.create",
      EDIT: "creation.ateliers.edit",
      DELETE: "creation.ateliers.delete",
    },
    POSTES: {
      VIEW: "creation.postes.view",
      CREATE: "creation.postes.create",
      EDIT: "creation.postes.edit",
      DELETE: "creation.postes.delete",
      EXPORT: "creation.postes.export",
    },
    PRESTATIONS: {
      VIEW: "creation.prestations.view",
      CREATE: "creation.prestations.create",
      EDIT: "creation.prestations.edit",
      DELETE: "creation.prestations.delete",
    },
    DOSSIER_TECHNIQUES: {
      VIEW: "creation.dossier_techniques.view",
      CREATE: "creation.dossier_techniques.create",
      EDIT: "creation.dossier_techniques.edit",
      DELETE: "creation.dossier_techniques.delete",
    },
    FAMILLE_ARTICLES: {
      VIEW: "creation.familleArticles.view",
      CREATE: "creation.familleArticles.create",
      EDIT: "creation.familleArticles.edit",
      DELETE: "creation.familleArticles.delete",
    },
    UNIVERS_COMMERCIAUX: {
      VIEW: "creation.universCommerciaux.view",
      CREATE: "creation.universCommerciaux.create",
      EDIT: "creation.universCommerciaux.edit",
      DELETE: "creation.universCommerciaux.delete",
    },
    LDF: {
      VIEW: "creation.ldf.view",
      CREATE: "creation.ldf.create",
      EDIT: "creation.ldf.edit",
      DELETE: "creation.ldf.delete",
    },
  },
  RH: {
    CONGES: {
      VIEW: "rh.conges.view",
      CREATE: "rh.conges.create",
      EDIT: "rh.conges.edit",
      DELETE: "rh.conges.delete",
      VALIDATE: "rh.conges.validate",
      VALIDATE_MANAGED: "rh.conges.validate_managed",
      CANCEL: "rh.conges.cancel",
      CANCEL_ANY: "rh.conges.cancel_any",
      CREATE_FOR_OTHERS: "rh.conges.create_for_others",
      CORRECT_SOLDE: "rh.conges.correct_solde",
      VIEW_DEPT: "rh.conges.view_dept",
    },
    POINTAGE: {
      VIEW: "rh.pointage.view",
      CREATE: "rh.pointage.create",
      EDIT: "rh.pointage.edit",
      VALIDATE: "rh.pointage.validate",
      POINT_SELF: "rh.pointage.point_self",
    },
    PLANIFICATION: {
      VIEW: "rh.planification.view",
      CREATE: "rh.planification.create",
      EDIT: "rh.planification.edit",
      VALIDATE: "rh.planification.validate",
    },
    FEUILLES_DE_TEMPS: {
      VIEW: "rh.feuilles_de_temps.view",
      CREATE: "rh.feuilles_de_temps.create",
      EDIT: "rh.feuilles_de_temps.edit",
      VALIDATE: "rh.feuilles_de_temps.validate",
    },
    DOCUMENTS: {
      VIEW: "rh.documents.view",
      CREATE: "rh.documents.create",
      EDIT: "rh.documents.edit",
      DELETE: "rh.documents.delete",
      DOWNLOAD: "rh.documents.download",
      EXPORT: "rh.documents.export",
      UPLOAD: "rh.documents.upload",
    },
    CONTRATS: {
      VIEW: "rh.contrats.view",
      CREATE: "rh.contrats.create",
      EDIT: "rh.contrats.edit",
      DELETE: "rh.contrats.delete",
    },
    AVENANTS: {
      VIEW: "rh.avenants.view",
      CREATE: "rh.avenants.create",
      EDIT: "rh.avenants.edit",
      VALIDATE: "rh.avenants.validate",
      SIGN: "rh.avenants.sign",
    },
    PERSONNE: {
      VIEW: "rh.personne.view",
      CREATE: "rh.personne.create",
      EDIT: "rh.personne.edit",
      ERASURE: "rh.personne.erasure",
    },
    PERSONNE_SENSITIVE: {
      VIEW: "rh.personne_sensitive.view",
    },
    COLLABORATEURS: {
      VIEW: "rh.collaborateurs.view",
    },
    FRAIS: {
      VIEW: "rh.frais.view",
      CREATE: "rh.frais.create",
      EDIT: "rh.frais.edit",
      DELETE: "rh.frais.delete",
      VALIDATE: "rh.frais.validate",
      PAID: "rh.frais.paid",
    },
    COMPETENCES: {
      VIEW: "rh.competences.view",
      CREATE: "rh.competences.create",
      EDIT: "rh.competences.edit",
      DELETE: "rh.competences.delete",
    },
    DEPARTEMENTS: {
      CREATE: "rh.departements.create",
      EDIT: "rh.departements.edit",
      DELETE: "rh.departements.delete",
    },
    EXTRACTIONS: {
      VIEW: "rh.extractions.view",
      EXPORT: "rh.extractions.export",
    },
    INDICATEURS: {
      VIEW: "rh.indicateurs.view",
      EXPORT: "rh.indicateurs.export",
    },
    PLANNING: {
      VIEW: "rh.planning.view",
      CREATE: "rh.planning.create",
      EDIT: "rh.planning.edit",
      DELETE: "rh.planning.delete",
    },
  },
  SECURITY: {
    USERS: {
      VIEW: "security.users.view",
      CREATE: "security.users.create",
      EDIT: "security.users.edit",
      DELETE: "security.users.delete",
      BULK_ASSIGN: "security.users.bulk-assign",
    },
    PROFILES: {
      VIEW: "security.profiles.view",
      CREATE: "security.profiles.create",
      EDIT: "security.profiles.edit",
      DELETE: "security.profiles.delete",
    },
    PERMISSIONS: {
      VIEW: "security.permissions.view",
      EDIT: "security.permissions.edit",
    },
    USER: {
      PERMISSIONS: "security.user.permissions.edit",
      ROLES: "security.user.roles.edit",
      PROFILE: "security.user.profile.change",
    },
    DELETED: {
      VIEW: "security.deleted.view",
    },
  },
  PRODUCTION: {
    OF: {
      VIEW: "production.of.view",
      CREATE: "production.of.create",
      EDIT: "production.of.edit",
      DELETE: "production.of.delete",
      LANCER: "production.of.lancer",
      CLOTURER: "production.of.cloturer",
      ARCHIVE: "production.of.archive",
    },
    CBNSAD: {
      VIEW: "production.cbnsad.view",
      CALCULATE: "production.cbnsad.calculate",
    },
    LANCEMENTS: {
      VIEW: "production.lancements.view",
      CREATE: "production.lancements.create",
      EDIT: "production.lancements.edit",
    },
    SUBSTITUTION: {
      CREATE: "production.substitution.create",
    },
    DECLARATIONS: {
      VIEW: "production.declarations.view",
      CREATE: "production.declarations.create",
      VALIDATE: "production.declarations.validate",
    },
    CLOTURE: {
      VIEW: "production.cloture.view",
      EXECUTE: "production.cloture.execute",
    },
    DASHBOARD: {
      VIEW: "production.dashboard.view",
    },
  },
  COMMERCE: {
    DASHBOARD: {
      VIEW: "commerce.dashboard.view",
    },
  },
  FACTURATION: {
    DASHBOARD: {
      VIEW: "facturation.dashboard.view",
    },
  },
  LOGISTIQUE: {
    DASHBOARD: {
      VIEW: "logistique.dashboard.view",
    },
  },
  QUALITE: {
    DASHBOARD: {
      VIEW: "qualite.dashboard.view",
    },
  },
  FINANCE: {
    DASHBOARD: {
      VIEW: "finance.dashboard.view",
    },
  },
  STOCK: {
    DASHBOARD: {
      VIEW: "stock.dashboard.view",
    },
    DEPOTS: {
      VIEW: "stock.depots.view",
      CREATE: "stock.depots.create",
      EDIT: "stock.depots.edit",
      DELETE: "stock.depots.delete",
    },
    EMPLACEMENTS: {
      VIEW: "stock.emplacements.view",
      CREATE: "stock.emplacements.create",
      EDIT: "stock.emplacements.edit",
      DELETE: "stock.emplacements.delete",
    },
    ZONES: {
      VIEW: "stock.zones.view",
      CREATE: "stock.zones.create",
      EDIT: "stock.zones.edit",
      DELETE: "stock.zones.delete",
    },
    MOVEMENTS: {
      VIEW: "stock.movements.view",
      CREATE: "stock.movements.create",
      EDIT: "stock.movements.edit",
      DELETE: "stock.movements.delete",
    },
    MOUVEMENTS: {
      VIEW: "stock.mouvements.view",
      CREATE: "stock.mouvements.create",
    },
    INVENTAIRES: {
      VIEW: "stock.inventaires.view",
      CREATE: "stock.inventaires.create",
      EDIT: "stock.inventaires.edit",
      DELETE: "stock.inventaires.delete",
    },
    CONSULTATION: {
      VIEW: "stock.consultation.view",
    },
    STOCK: {
      VIEW: "stock.view",
      CREATE: "stock.create",
      EDIT: "stock.edit",
      DELETE: "stock.delete",
    },
  },
  DOCUMENTS: {
    VIEW: "documents.view",
    CREATE: "documents.create",
    EDIT: "documents.edit",
    DELETE: "documents.delete",
    DOWNLOAD: "documents.download",
    EXPORT: "documents.export",
    UPLOAD: "documents.upload",
  },
  SETTINGS: {
    USER: {
      VIEW: "settings.user.view",
      EDIT: "settings.user.edit",
    },
  },
  ACHATS: {
    FOURNISSEURS: {
      VIEW: "achats.fournisseurs.view",
      CREATE: "achats.fournisseurs.create",
      EDIT: "achats.fournisseurs.edit",
      DELETE: "achats.fournisseurs.delete",
      EXPORT: "achats.fournisseurs.export",
      IMPORT: "achats.fournisseurs.import",
    },
    FOURNITURES: {
      VIEW: "achats.fournitures.view",
      CREATE: "achats.fournitures.create",
      EDIT: "achats.fournitures.edit",
      DELETE: "achats.fournitures.delete",
    },
    COMMANDES: {
      VIEW: "achats.commandes.view",
      CREATE: "achats.commandes.create",
      EDIT: "achats.commandes.edit",
      DELETE: "achats.commandes.delete",
      VALIDATE: "achats.commandes.validate",
    },
    RECEPTIONS: {
      VIEW: "achats.receptions.view",
      CREATE: "achats.receptions.create",
      EDIT: "achats.receptions.edit",
      DELETE: "achats.receptions.delete",
      VALIDATE: "achats.receptions.validate",
      FACTURER: "achats.receptions.facturer",
      AJOUTER_PRESTATION: "achats.receptions.ajouter_prestation",
    },
    FACTURES: {
      VIEW: "achats.factures.view",
      CREATE: "achats.factures.create",
      EDIT: "achats.factures.edit",
      DELETE: "achats.factures.delete",
      PAY: "achats.factures.pay",
      TRANSFERER_COMPTA: "achats.factures.transferer_compta",
    },
    PRESTATIONS: {
      VIEW: "achats.prestations.view",
      CREATE: "achats.prestations.create",
      EDIT: "achats.prestations.edit",
      DELETE: "achats.prestations.delete",
    },
    FAMILLES_PRESTATION: {
      VIEW: "achats.famillesPrestation.view",
      CREATE: "achats.famillesPrestation.create",
      EDIT: "achats.famillesPrestation.edit",
      DELETE: "achats.famillesPrestation.delete",
    },
  },
  VENTES: {
    CATEGORIES: {
      VIEW: "ventes.categories.view",
      CREATE: "ventes.categories.create",
      EDIT: "ventes.categories.edit",
      DELETE: "ventes.categories.delete",
    },
    GRILLES: {
      VIEW: "ventes.grilles.view",
      CREATE: "ventes.grilles.create",
      EDIT: "ventes.grilles.edit",
      DELETE: "ventes.grilles.delete",
    },
    PROMOTIONS: {
      VIEW: "ventes.promotions.view",
      CREATE: "ventes.promotions.create",
      EDIT: "ventes.promotions.edit",
      DELETE: "ventes.promotions.delete",
    },
    PROFILS: {
      VIEW: "ventes.profils.view",
      CREATE: "ventes.profils.create",
      EDIT: "ventes.profils.edit",
      DELETE: "ventes.profils.delete",
    },
    TAXES: {
      VIEW: "ventes.taxes.view",
      CREATE: "ventes.taxes.create",
      EDIT: "ventes.taxes.edit",
      DELETE: "ventes.taxes.delete",
    },
    ORGANISMES: {
      VIEW: "ventes.organismes.view",
      CREATE: "ventes.organismes.create",
      EDIT: "ventes.organismes.edit",
      DELETE: "ventes.organismes.delete",
    },
    TARIFS: {
      VIEW: "ventes.tarifs.view",
      CREATE: "ventes.tarifs.create",
      EDIT: "ventes.tarifs.edit",
      DELETE: "ventes.tarifs.delete",
    },
    CRM: {
      VIEW: "ventes.crm.view",
    },
    CLIENTS: {
      VIEW: "ventes.clients.view",
      CREATE: "ventes.clients.create",
      EDIT: "ventes.clients.edit",
      DELETE: "ventes.clients.delete",
      BLOCK: "ventes.clients.block",
      EXPORT: "ventes.clients.export",
    },
    COMMANDES: {
      VIEW: "ventes.commandes.view",
      CREATE: "ventes.commandes.create",
      EDIT: "ventes.commandes.edit",
      DELETE: "ventes.commandes.delete",
      VALIDATE: "ventes.commandes.validate",
      PREPARER: "ventes.commandes.preparer",
      EXPEDIER: "ventes.commandes.expedier",
      FACTURER: "ventes.commandes.facturer",
      PROFORMA: "ventes.commandes.proforma",
    },
    EXPEDITIONS: {
      VIEW: "ventes.expeditions.view",
      CREATE: "ventes.expeditions.create",
      EDIT: "ventes.expeditions.edit",
      DELETE: "ventes.expeditions.delete",
      PREPARER: "ventes.expeditions.preparer",
      EXPEDIER: "ventes.expeditions.expedier",
      PARAMS: "ventes.expeditions.params",
      VALIDATE: "ventes.expeditions.validate",
    },
    FACTURATION: {
      VIEW: "ventes.facturation.view",
      CREATE: "ventes.facturation.create",
      EDIT: "ventes.facturation.edit",
      DELETE: "ventes.facturation.delete",
      ANNULER: "ventes.facturation.annuler",
      ENCAISSER: "ventes.facturation.encaisser",
      IMPAYER: "ventes.facturation.impayer",
      TAMPONNER: "ventes.facturation.tamponner",
      TRANSFERER_COMPTA: "ventes.facturation.transferer_compta",
    },
    FACTURES: {
      VIEW: "ventes.factures.view",
      CREATE: "ventes.factures.create",
      EDIT: "ventes.factures.edit",
      DELETE: "ventes.factures.delete",
      PAY: "ventes.factures.pay",
      TRANSFERER_COMPTA: "ventes.factures.transferer_compta",
    },
    REGLEMENTS: {
      VIEW: "ventes.reglements.view",
      CREATE: "ventes.reglements.create",
      DELETE: "ventes.reglements.delete",
    },
  },
  COMPTABILITE: {
    RELANCES: {
      VIEW: "comptabilite.relances.view",
      CREATE: "comptabilite.relances.create",
      EDIT: "comptabilite.relances.edit",
      DELETE: "comptabilite.relances.delete",
    },
    ECOTAXES: {
      VIEW: "comptabilite.ecotaxes.view",
      DECLARE: "comptabilite.ecotaxes.declare",
      EDIT: "comptabilite.ecotaxes.edit",
      DELETE: "comptabilite.ecotaxes.delete",
    },
    REGLEMENTS: {
      VIEW: "comptabilite.reglements.view",
      CREATE: "comptabilite.reglements.create",
      DELETE: "comptabilite.reglements.delete",
    },
    ECHEANCES: {
      VIEW: "comptabilite.echeances.view",
    },
  },
  SHARED: {
    NOTIFICATION: {
      VIEW: "shared.notification.view",
      CREATE: "shared.notification.create",
      EDIT: "shared.notification.edit",
      DELETE: "shared.notification.delete",
    },
  },
  TICKETS: {
    TICKETS: {
      VIEW: "tickets.tickets.view",
      CREATE: "tickets.tickets.create",
      EDIT: "tickets.tickets.edit",
      DEV: "tickets.tickets.dev",
      PROPOSE_SOLUTION: "tickets.tickets.propose_solution",
      VALIDATE_SOLUTION: "tickets.tickets.validate_solution",
      REJECT_SOLUTION: "tickets.tickets.reject_solution",
      CLOSE: "tickets.tickets.close",
      REOPEN: "tickets.tickets.reopen",
      DELETE: "tickets.tickets.delete",
    },
    COMMENTS: {
      CREATE: "tickets.comments.create",
    },
  },
} as const;

/**
 * Union type of all permission strings — generated from PermissionCode.php constants.
 */
export type PermissionString =
  | "creation.employes.view"
  | "creation.articles.view"
  | "creation.articles.create"
  | "creation.articles.edit"
  | "creation.articles.delete"
  | "creation.articles.archive"
  | "creation.articles.export"
  | "creation.articles.import"
  | "creation.documents.view"
  | "creation.documents.create"
  | "creation.documents.edit"
  | "creation.documents.delete"
  | "creation.documents.download"
  | "creation.documents.upload"
  | "creation.documents.export"
  | "creation.ateliers.view"
  | "creation.ateliers.create"
  | "creation.ateliers.edit"
  | "creation.ateliers.delete"
  | "creation.postes.view"
  | "creation.postes.create"
  | "creation.postes.edit"
  | "creation.postes.delete"
  | "creation.postes.export"
  | "creation.prestations.view"
  | "creation.prestations.create"
  | "creation.prestations.edit"
  | "creation.prestations.delete"
  | "creation.dossier_techniques.view"
  | "creation.dossier_techniques.create"
  | "creation.dossier_techniques.edit"
  | "creation.dossier_techniques.delete"
  | "creation.familleArticles.view"
  | "creation.familleArticles.create"
  | "creation.familleArticles.edit"
  | "creation.familleArticles.delete"
  | "creation.universCommerciaux.view"
  | "creation.universCommerciaux.create"
  | "creation.universCommerciaux.edit"
  | "creation.universCommerciaux.delete"
  | "creation.ldf.view"
  | "creation.ldf.create"
  | "creation.ldf.edit"
  | "creation.ldf.delete"
  | "rh.conges.view"
  | "rh.conges.create"
  | "rh.conges.edit"
  | "rh.conges.delete"
  | "rh.conges.validate"
  | "rh.conges.validate_managed"
  | "rh.conges.cancel"
  | "rh.conges.cancel_any"
  | "rh.conges.create_for_others"
  | "rh.conges.correct_solde"
  | "rh.conges.view_dept"
  | "rh.pointage.view"
  | "rh.pointage.create"
  | "rh.pointage.edit"
  | "rh.pointage.validate"
  | "rh.pointage.point_self"
  | "rh.planification.view"
  | "rh.planification.create"
  | "rh.planification.edit"
  | "rh.planification.validate"
  | "rh.feuilles_de_temps.view"
  | "rh.feuilles_de_temps.create"
  | "rh.feuilles_de_temps.edit"
  | "rh.feuilles_de_temps.validate"
  | "rh.documents.view"
  | "rh.documents.create"
  | "rh.documents.edit"
  | "rh.documents.delete"
  | "rh.documents.download"
  | "rh.documents.export"
  | "rh.documents.upload"
  | "rh.contrats.view"
  | "rh.contrats.create"
  | "rh.contrats.edit"
  | "rh.contrats.delete"
  | "rh.avenants.view"
  | "rh.avenants.create"
  | "rh.avenants.edit"
  | "rh.avenants.validate"
  | "rh.avenants.sign"
  | "rh.personne.view"
  | "rh.personne.create"
  | "rh.personne.edit"
  | "rh.personne_sensitive.view"
  | "rh.personne.erasure"
  | "rh.collaborateurs.view"
  | "rh.frais.view"
  | "rh.frais.create"
  | "rh.frais.edit"
  | "rh.competences.view"
  | "rh.competences.create"
  | "rh.competences.edit"
  | "rh.competences.delete"
  | "rh.departements.create"
  | "rh.departements.edit"
  | "rh.departements.delete"
  | "rh.extractions.view"
  | "rh.extractions.export"
  | "rh.frais.delete"
  | "rh.frais.validate"
  | "rh.frais.paid"
  | "rh.indicateurs.view"
  | "rh.indicateurs.export"
  | "rh.planning.view"
  | "rh.planning.create"
  | "rh.planning.edit"
  | "rh.planning.delete"
  | "security.users.view"
  | "security.users.create"
  | "security.users.edit"
  | "security.users.delete"
  | "security.profiles.view"
  | "security.profiles.create"
  | "security.profiles.edit"
  | "security.profiles.delete"
  | "security.permissions.view"
  | "security.permissions.edit"
  | "security.user.permissions.edit"
  | "security.user.roles.edit"
  | "security.user.profile.change"
  | "security.users.bulk-assign"
  | "security.deleted.view"
  | "production.of.view"
  | "production.of.create"
  | "production.of.edit"
  | "production.of.delete"
  | "production.of.lancer"
  | "production.of.cloturer"
  | "production.of.archive"
  | "production.cbnsad.view"
  | "production.cbnsad.calculate"
  | "production.lancements.view"
  | "production.lancements.create"
  | "production.lancements.edit"
  | "production.substitution.create"
  | "production.declarations.view"
  | "production.declarations.create"
  | "production.declarations.validate"
  | "production.cloture.view"
  | "production.cloture.execute"
  | "production.dashboard.view"
  | "commerce.dashboard.view"
  | "facturation.dashboard.view"
  | "logistique.dashboard.view"
  | "qualite.dashboard.view"
  | "finance.dashboard.view"
  | "stock.dashboard.view"
  | "stock.depots.view"
  | "stock.depots.create"
  | "stock.depots.edit"
  | "stock.depots.delete"
  | "stock.emplacements.view"
  | "stock.emplacements.create"
  | "stock.emplacements.edit"
  | "stock.emplacements.delete"
  | "stock.zones.view"
  | "stock.zones.create"
  | "stock.zones.edit"
  | "stock.zones.delete"
  | "stock.movements.view"
  | "stock.movements.create"
  | "stock.movements.edit"
  | "stock.movements.delete"
  | "stock.mouvements.view"
  | "stock.mouvements.create"
  | "stock.inventaires.view"
  | "stock.inventaires.create"
  | "stock.inventaires.edit"
  | "stock.inventaires.delete"
  | "stock.consultation.view"
  | "documents.view"
  | "documents.create"
  | "documents.edit"
  | "documents.delete"
  | "documents.download"
  | "documents.export"
  | "documents.upload"
  | "settings.user.view"
  | "settings.user.edit"
  | "stock.view"
  | "stock.create"
  | "stock.edit"
  | "stock.delete"
  | "achats.fournisseurs.view"
  | "achats.fournisseurs.create"
  | "achats.fournisseurs.edit"
  | "achats.fournisseurs.delete"
  | "achats.fournisseurs.export"
  | "achats.fournisseurs.import"
  | "achats.fournitures.view"
  | "achats.fournitures.create"
  | "achats.fournitures.edit"
  | "achats.fournitures.delete"
  | "achats.commandes.view"
  | "achats.commandes.create"
  | "achats.commandes.edit"
  | "achats.commandes.delete"
  | "achats.commandes.validate"
  | "achats.receptions.view"
  | "achats.receptions.create"
  | "achats.receptions.edit"
  | "achats.receptions.delete"
  | "achats.receptions.validate"
  | "achats.receptions.facturer"
  | "achats.receptions.ajouter_prestation"
  | "achats.factures.view"
  | "achats.factures.create"
  | "achats.factures.edit"
  | "achats.factures.delete"
  | "achats.factures.pay"
  | "achats.factures.transferer_compta"
  | "ventes.categories.view"
  | "ventes.categories.create"
  | "ventes.categories.edit"
  | "ventes.categories.delete"
  | "ventes.grilles.view"
  | "ventes.grilles.create"
  | "ventes.grilles.edit"
  | "ventes.grilles.delete"
  | "ventes.promotions.view"
  | "ventes.promotions.create"
  | "ventes.promotions.edit"
  | "ventes.promotions.delete"
  | "ventes.profils.view"
  | "ventes.profils.create"
  | "ventes.profils.edit"
  | "ventes.profils.delete"
  | "ventes.taxes.view"
  | "ventes.taxes.create"
  | "ventes.taxes.edit"
  | "ventes.taxes.delete"
  | "ventes.organismes.view"
  | "ventes.organismes.create"
  | "ventes.organismes.edit"
  | "ventes.organismes.delete"
  | "ventes.tarifs.view"
  | "ventes.tarifs.create"
  | "ventes.tarifs.edit"
  | "ventes.tarifs.delete"
  | "ventes.crm.view"
  | "ventes.clients.view"
  | "ventes.clients.create"
  | "ventes.clients.edit"
  | "ventes.clients.delete"
  | "ventes.clients.block"
  | "ventes.clients.export"
  | "ventes.commandes.view"
  | "ventes.commandes.create"
  | "ventes.commandes.edit"
  | "ventes.commandes.delete"
  | "ventes.commandes.validate"
  | "ventes.commandes.preparer"
  | "ventes.commandes.expedier"
  | "ventes.commandes.facturer"
  | "ventes.commandes.proforma"
  | "ventes.expeditions.view"
  | "ventes.expeditions.create"
  | "ventes.expeditions.edit"
  | "ventes.expeditions.delete"
  | "ventes.expeditions.preparer"
  | "ventes.expeditions.expedier"
  | "ventes.expeditions.params"
  | "ventes.expeditions.validate"
  | "ventes.facturation.view"
  | "ventes.facturation.create"
  | "ventes.facturation.edit"
  | "ventes.facturation.delete"
  | "ventes.facturation.annuler"
  | "ventes.facturation.encaisser"
  | "ventes.facturation.impayer"
  | "ventes.facturation.tamponner"
  | "ventes.facturation.transferer_compta"
  | "ventes.factures.view"
  | "ventes.factures.create"
  | "ventes.factures.edit"
  | "ventes.factures.delete"
  | "ventes.factures.pay"
  | "ventes.factures.transferer_compta"
  | "ventes.reglements.view"
  | "ventes.reglements.create"
  | "ventes.reglements.delete"
  | "achats.prestations.view"
  | "achats.prestations.create"
  | "achats.prestations.edit"
  | "achats.prestations.delete"
  | "achats.famillesPrestation.view"
  | "achats.famillesPrestation.create"
  | "achats.famillesPrestation.edit"
  | "achats.famillesPrestation.delete"
  | "comptabilite.relances.view"
  | "comptabilite.relances.create"
  | "comptabilite.relances.edit"
  | "comptabilite.relances.delete"
  | "comptabilite.ecotaxes.view"
  | "comptabilite.ecotaxes.declare"
  | "comptabilite.ecotaxes.edit"
  | "comptabilite.ecotaxes.delete"
  | "comptabilite.reglements.view"
  | "comptabilite.reglements.create"
  | "comptabilite.reglements.delete"
  | "comptabilite.echeances.view"
  | "shared.notification.view"
  | "shared.notification.create"
  | "shared.notification.edit"
  | "shared.notification.delete"
  | "tickets.tickets.view"
  | "tickets.tickets.create"
  | "tickets.tickets.edit"
  | "tickets.tickets.dev"
  | "tickets.tickets.propose_solution"
  | "tickets.tickets.validate_solution"
  | "tickets.tickets.reject_solution"
  | "tickets.tickets.close"
  | "tickets.tickets.reopen"
  | "tickets.tickets.delete"
  | "tickets.comments.create";
